import {utilHelper} from "../../_helpers";
import {LB_NOTIFICATION_ADDED, LB_NOTIFICATION_DELETED} from "../../../components/i18n/i18n";

const relativeUrl = 'api/notificationActivity'

export const notificationActivityService = {
    add,
    remove
}

function add(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/add`, 'POST', { data, message:LB_NOTIFICATION_ADDED })
}

function remove(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/remove`, 'POST', { data, message:LB_NOTIFICATION_DELETED })
}